import { useRouteContext } from '@tanstack/react-router';

export function useApi() {
  const { apiClient } = useRouteContext({ from: '__root__' });
  return apiClient;
}
